App.controller('ConfirmRelativeRegistrationCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$stateParams', 'authService', '$mdDialog', function ($scope, $sce, $state, $http, Config, $stateParams, authService, $mdDialog) {
	$scope.stateParams = $stateParams;

    $scope.acceptStatement = true;
    $scope.token = $scope.stateParams.token;
    console.log($scope.token);

    $scope.$watch('password', function() {
        if (!$scope.password) {
            $scope.strongPassword = 0;
            return 0;
        } else {
            $scope.strongPassword = $scope.password.length * 10/2;

            if ($scope.strongPassword <= 40) {
                $scope.strongPasswordLabel = 'Słabe';
            } else if ($scope.strongPassword <= 60) {
                $scope.strongPasswordLabel = 'Średnie';
            } else if ($scope.strongPassword <= 80) {
                $scope.strongPasswordLabel = 'Dobre';
            } else {
                $scope.strongPasswordLabel = 'Znakomite';
            }
        }
    });

    $scope.confirm = function() {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        $scope.data = {
            password: $scope.password,
            token: $scope.token
        }
        authService.confirmRegistrationChild($scope.data).then(function (data) {
            if (data.status === 200) {
                $state.go('root.login');
            } else {
                $scope.showPopUp('', 'Niepoprawny token', 'Token do potwierdzenia rejestracji jest niepoprawny, skontaktuj się z administratorem.', '', '');
            }
        });
    }

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            
        }, function() {
            
        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
}]);